module.exports = {
  view: {
    flexbox: 'vertical',
    flex: 1
  }
};


//////////////////
// WEBPACK FOOTER
// ./lib/presets/default.js
// module id = 13
// module chunks = 0